// Generated by ui/tools/i18n.mjs from en.json. Do not edit: change the JSON and run `node ../../../packages/ui/tools/i18n.mjs compile .` in web/.
import type { Catalogue } from '../i18n/translator';

/** Every message id this app has (t() only accepts these). */
export type MessageId =
  | "beta.caution"
  | "beta.help"
  | "beta.off"
  | "beta.scope"
  | "beta.status"
  | "beta.title"
  | "beta.warmup"
  | "ui.accounts.add"
  | "ui.accounts.button"
  | "ui.accounts.button_work"
  | "ui.accounts.manage"
  | "ui.accounts.max"
  | "ui.accounts.menu"
  | "ui.accounts.new_tab"
  | "ui.accounts.new_tab_label"
  | "ui.accounts.remove"
  | "ui.accounts.remove_label"
  | "ui.accounts.sign_in_again"
  | "ui.accounts.sign_out"
  | "ui.accounts.sign_out_all"
  | "ui.accounts.sign_out_of"
  | "ui.accounts.signed_out"
  | "ui.accounts.signed_out_label"
  | "ui.accounts.switch_to"
  | "ui.accounts.unread"
  | "ui.accounts.unread_elsewhere"
  | "ui.accounts.work"
  | "ui.apps.ask"
  | "ui.apps.ask_blocked"
  | "ui.apps.ask_close"
  | "ui.apps.ask_new_tab"
  | "ui.apps.create"
  | "ui.apps.label"
  | "ui.bell.about"
  | "ui.bell.about_assigned"
  | "ui.bell.about_comment"
  | "ui.bell.about_files"
  | "ui.bell.about_invitation"
  | "ui.bell.about_keyword"
  | "ui.bell.about_mention"
  | "ui.bell.about_message"
  | "ui.bell.about_reminder"
  | "ui.bell.about_reply"
  | "ui.bell.about_share"
  | "ui.bell.an_item"
  | "ui.bell.app_calendar"
  | "ui.bell.app_chat"
  | "ui.bell.app_contacts"
  | "ui.bell.app_docs"
  | "ui.bell.app_drive"
  | "ui.bell.app_mail"
  | "ui.bell.app_sheets"
  | "ui.bell.app_slides"
  | "ui.bell.app_tasks"
  | "ui.bell.assigned"
  | "ui.bell.back"
  | "ui.bell.comment"
  | "ui.bell.due"
  | "ui.bell.earlier"
  | "ui.bell.email_title"
  | "ui.bell.empty"
  | "ui.bell.failed"
  | "ui.bell.h_ago"
  | "ui.bell.how_often"
  | "ui.bell.invitation"
  | "ui.bell.just_now"
  | "ui.bell.keyword"
  | "ui.bell.loading"
  | "ui.bell.mark_all"
  | "ui.bell.mention"
  | "ui.bell.message"
  | "ui.bell.min_ago"
  | "ui.bell.note"
  | "ui.bell.often_daily"
  | "ui.bell.often_off"
  | "ui.bell.often_soon"
  | "ui.bell.others"
  | "ui.bell.reminder"
  | "ui.bell.reminder_sub"
  | "ui.bell.reply"
  | "ui.bell.save_failed"
  | "ui.bell.saved"
  | "ui.bell.settings"
  | "ui.bell.share"
  | "ui.bell.someone"
  | "ui.bell.title"
  | "ui.bell.today"
  | "ui.bell.unchecked"
  | "ui.bell.unread"
  | "ui.bell.updated"
  | "ui.bell.virus"
  | "ui.cancel"
  | "ui.commands.ask_docs"
  | "ui.commands.ask_sheets"
  | "ui.commands.ask_slides"
  | "ui.commands.list"
  | "ui.commands.none"
  | "ui.commands.title"
  | "ui.date.bad_time"
  | "ui.date.choose"
  | "ui.date.date"
  | "ui.date.field"
  | "ui.date.next"
  | "ui.date.not_set"
  | "ui.date.past"
  | "ui.date.previous"
  | "ui.date.quick"
  | "ui.date.suggested"
  | "ui.date.time"
  | "ui.date.type_time"
  | "ui.date.type_time_now"
  | "ui.done"
  | "ui.frame.open"
  | "ui.frame.opening"
  | "ui.frame.slow"
  | "ui.keys.action"
  | "ui.keys.clash"
  | "ui.keys.first"
  | "ui.keys.help"
  | "ui.keys.here"
  | "ui.keys.no_key"
  | "ui.keys.none"
  | "ui.keys.not_yet"
  | "ui.keys.or"
  | "ui.keys.search"
  | "ui.keys.search_example"
  | "ui.keys.single"
  | "ui.keys.single_hint"
  | "ui.keys.title"
  | "ui.rail.actions"
  | "ui.rail.add"
  | "ui.rail.add_app"
  | "ui.rail.badges"
  | "ui.rail.badges_hint"
  | "ui.rail.count"
  | "ui.rail.customise"
  | "ui.rail.customise_hint"
  | "ui.rail.customise_title"
  | "ui.rail.dot"
  | "ui.rail.down"
  | "ui.rail.home"
  | "ui.rail.keep"
  | "ui.rail.more"
  | "ui.rail.move_app_down"
  | "ui.rail.move_app_up"
  | "ui.rail.move_down"
  | "ui.rail.move_up"
  | "ui.rail.new_tab"
  | "ui.rail.nothing"
  | "ui.rail.remove"
  | "ui.rail.remove_app"
  | "ui.rail.remove_short"
  | "ui.rail.reset"
  | "ui.rail.show"
  | "ui.rail.show_app"
  | "ui.rail.up"
  | "ui.rail.your_bar"
  | "ui.select.none"
  | "ui.select.search"
  | "ui.select.search_in"
  | "ui.share.copy_link"
  | "ui.share.general_access"
  | "ui.sidebar.hide"
  | "ui.sidebar.name"
  | "ui.sidebar.resize"
  | "ui.sidebar.resize_named"
  | "ui.sidebar.resize_panel"
  | "ui.sidebar.show"
  | "ui.theme.accent"
  | "ui.theme.appearance";

const catalogue: Catalogue = {"status":"source","messages":{"beta.title":["Trying Dugzi during the beta"],"beta.scope":["Welcome to Dugzi. You can use Mail and Contacts, and manage sign-in and recovery in your account."],"beta.off":["Sharing between accounts, shared spaces and sign-in with Dugzi in outside apps are off for now. The other products are not available. Ordinary email works."],"beta.warmup":["Our mail service is new: mail to other providers may wait, come back with a delivery report, or land in spam at first."],"beta.caution":["Keep your old address for important mail: your bank, government, health, work and account recovery."],"beta.help":["Need help? Write to support@dugzi.com."],"beta.status":["Service updates: status.dugzi.com."],"ui.accounts.work":["Work"],"ui.accounts.button":["Account: ",["name"],", ",["address"]],"ui.accounts.button_work":["Account: ",["name"],", ",["address"]," (work)"],"ui.accounts.unread_elsewhere":[["count"]," unread in your other accounts"],"ui.accounts.menu":["Accounts"],"ui.accounts.switch_to":["Switch to"],"ui.accounts.signed_out_label":[["name"],", ",["address"],": signed out. Sign in again"],"ui.accounts.signed_out":["Signed out"],"ui.accounts.sign_in_again":["Sign in again"],"ui.accounts.unread":[["count"]," unread"],"ui.accounts.new_tab":["Open in a new tab"],"ui.accounts.new_tab_label":["Open ",["address"]," in a new tab"],"ui.accounts.remove":["Remove from this device"],"ui.accounts.remove_label":["Remove ",["address"]," from this device"],"ui.accounts.add":["Add another account"],"ui.accounts.max":["You can have ",["max"]," accounts on this device."],"ui.accounts.manage":["Manage your ",["brand"]," Account"],"ui.accounts.sign_out":["Sign out"],"ui.accounts.sign_out_of":["Sign out of ",["address"]],"ui.accounts.sign_out_all":["Sign out of all accounts"],"ui.apps.label":[["brand"]," apps"],"ui.apps.ask":["Ask ",["brand"]],"ui.apps.create":["Create, in a new tab"],"ui.apps.ask_new_tab":["Open Ask ",["brand"]," in a new tab"],"ui.apps.ask_close":["Close Ask ",["brand"]],"ui.apps.ask_blocked":["This app can't show Ask ",["brand"]," beside it yet."],"ui.done":["Done"],"ui.rail.new_tab":["Open in a new tab"],"ui.rail.show":["Show on the bar"],"ui.rail.count":["Count"],"ui.rail.dot":["Dot"],"ui.rail.nothing":["Nothing"],"ui.rail.move_up":["Move up"],"ui.rail.move_down":["Move down"],"ui.rail.remove":["Remove from bar"],"ui.rail.keep":["Keep in bar"],"ui.rail.customise":["Customise bar…"],"ui.rail.home":["Home"],"ui.rail.actions":[["app"]," actions"],"ui.rail.customise_title":["Customise the app bar"],"ui.rail.reset":["Reset"],"ui.rail.customise_hint":["Up to ",["max"]," apps on the bar (g then 6–9 opens the sixth to the ninth; g then 1–5 switches accounts); phones show the first 4. Saved to your ",["account"],"."],"ui.rail.badges":["Show badges on the bar"],"ui.rail.badges_hint":["Turn off on a shared screen. Notifications stay in the bell."],"ui.rail.your_bar":["Your bar"],"ui.rail.show_app":[["app"],": show on the bar"],"ui.rail.move_app_up":["Move ",["app"]," up"],"ui.rail.up":["Up"],"ui.rail.move_app_down":["Move ",["app"]," down"],"ui.rail.down":["Down"],"ui.rail.remove_app":["Remove ",["app"]," from the bar"],"ui.rail.remove_short":["Remove"],"ui.rail.more":["More apps"],"ui.rail.add_app":["Add ",["app"]," to the bar"],"ui.rail.add":["Add to bar"],"ui.keys.title":["Keyboard shortcuts"],"ui.keys.search_example":["For example: centre, ",["keys"],", Format Painter"],"ui.keys.search":["Search the shortcuts"],"ui.keys.clash":["Where keys clash"],"ui.keys.first":[["name"]," first"],"ui.keys.single":["Single-key shortcuts"],"ui.keys.single_hint":["Keys like ? and B act only while the slide or the presentation has focus."],"ui.keys.help":["Keys from ",["office"]," and ",["google"]," both work. Where they clash, the one you choose above wins. Struck-through keys are kept by your browser in a tab or do something else here; the keys on the left work."],"ui.keys.action":["Action"],"ui.keys.here":["Keys here"],"ui.keys.not_yet":["Not yet"],"ui.keys.none":["No shortcut matches “",["q"],"”. Try the command search: ",["keys"],"."],"ui.keys.no_key":["none"],"ui.bell.share":[["who"]," shared <b>",["title"],"</b> with you"],"ui.bell.mention":[["who"]," mentioned you in <b>",["title"],"</b>"],"ui.bell.comment":[["who"]," commented on <b>",["title"],"</b>"],"ui.bell.reply":[["who"]," replied in <b>",["title"],"</b>"],"ui.bell.invitation":[["who"]," invited you to <b>",["title"],"</b>"],"ui.bell.assigned":[["who"]," assigned you <b>",["title"],"</b>"],"ui.bell.message":[["who"]," sent you a message: <b>",["title"],"</b>"],"ui.bell.reminder":["Reminder: <b>",["title"],"</b>"],"ui.bell.due":["Due: <b>",["title"],"</b>"],"ui.bell.virus":["We found a virus in <b>",["title"],"</b>, so its public link is off"],"ui.bell.unchecked":["We couldn’t check <b>",["title"],"</b> for viruses, so its public link isn’t working"],"ui.bell.keyword":[["who"]," wrote a word you follow in <b>",["title"],"</b>"],"ui.bell.reminder_sub":["Reminder: <b>",["title"],"</b> · ",["subtitle"]],"ui.bell.updated":[["who"]," updated <b>",["title"],"</b>"],"ui.bell.someone":["Someone"],"ui.bell.others":[["first"]," and ",["count","plural",{"one":[["count"]," other"],"other":[["count"]," others"]}]],"ui.bell.an_item":["an item"],"ui.bell.app_docs":["Docs"],"ui.bell.app_sheets":["Sheets"],"ui.bell.app_slides":["Slides"],"ui.bell.app_drive":["Drive"],"ui.bell.app_calendar":["Calendar"],"ui.bell.app_tasks":["Tasks"],"ui.bell.app_chat":["Chat"],"ui.bell.app_contacts":["Contacts"],"ui.bell.app_mail":["Mail"],"ui.bell.about_share":["Shared with you"],"ui.bell.about_mention":["Mentions"],"ui.bell.about_comment":["Comments"],"ui.bell.about_reply":["Replies"],"ui.bell.about_invitation":["Invitations"],"ui.bell.about_reminder":["Reminders"],"ui.bell.about_assigned":["Assigned to you"],"ui.bell.about_message":["Direct messages"],"ui.bell.about_keyword":["Words you follow"],"ui.bell.about_files":["File checks"],"ui.bell.just_now":["just now"],"ui.bell.min_ago":[["count"]," min ago"],"ui.bell.h_ago":[["count"]," h ago"],"ui.bell.today":["Today"],"ui.bell.earlier":["Earlier"],"ui.bell.title":["Notifications"],"ui.bell.settings":["Notification settings"],"ui.bell.failed":["Notifications aren't reachable right now."],"ui.bell.loading":["Loading…"],"ui.bell.empty":["You're all caught up."],"ui.bell.unread":["Unread:"],"ui.bell.saved":["Saved"],"ui.bell.save_failed":["Couldn't save"],"ui.bell.back":["Back to notifications"],"ui.bell.email_title":["Email me when no ",["brand"]," tab is open"],"ui.bell.how_often":["How often"],"ui.bell.often_soon":["At most every 15 minutes"],"ui.bell.often_daily":["Once a day"],"ui.bell.often_off":["Never"],"ui.bell.about":["About"],"ui.bell.note":["In-app notifications always show here. Emails go to your ",["brand"]," address and name who did what, with a link."],"ui.frame.slow":[["app"]," is taking long to open."],"ui.frame.open":["Open it in a new tab"],"ui.frame.opening":["Opening ",["app"]],"ui.select.search_in":["Search ",["label"]],"ui.select.search":["Search"],"ui.select.none":["Nothing matches"],"ui.share.general_access":["General access"],"ui.share.copy_link":["Copy link"],"ui.commands.title":["Search the menus"],"ui.commands.ask_sheets":["What do you want to do? For example: freeze panes, pivot table"],"ui.commands.ask_docs":["What do you want to do? For example: track changes, format painter"],"ui.commands.ask_slides":["What do you want to do? For example: presenter view, group"],"ui.commands.list":["Commands"],"ui.commands.none":["Nothing matches “",["q"],"”. Try another word, or the name ",["office"]," or ",["google"]," uses."],"ui.date.field":[["label"],": ",["value"]],"ui.date.not_set":["not set"],"ui.date.choose":["Choose ",["label"]],"ui.date.type_time":["Type a time, e.g. ",["example"]],"ui.date.type_time_now":["Type a time (now ",["time"],")"],"ui.date.bad_time":["Try 9.30, 14:00 or 9pm."],"ui.date.suggested":["Suggested times for ",["label"]],"ui.date.quick":["Quick choices"],"ui.date.date":["Date"],"ui.date.time":["Time"],"ui.date.past":["That's in the past. Pick a later time."],"ui.cancel":["Cancel"],"ui.date.previous":["Previous month"],"ui.date.next":["Next month"],"ui.theme.appearance":["Appearance"],"ui.theme.accent":["Accent colour"],"ui.sidebar.name":["sidebar"],"ui.sidebar.resize":["Resize sidebar"],"ui.sidebar.resize_named":["Resize ",["label"]],"ui.sidebar.resize_panel":["Resize panel"],"ui.sidebar.show":["Show sidebar"],"ui.sidebar.hide":["Hide sidebar"],"ui.bell.mark_all":["Mark all read"],"ui.keys.or":["or"]}};
export default catalogue;
